module.exports = "/_next/static/images/Hero@2x-78a91e9e9ee30e883e0144734e7511df.png";